<template>
  <div v-if="!isCookieAgreed" class="cookie-banner position-sticky left-0 right-0 bottom-0 p-4 p-xxl-5 bg-white">
    <div class="d-flex flex-column flex-lg-row align-items-center mx-xxl-5 px-xxl-5">
      <div class="mb-4 mb-lg-0">
        <img v-if="footerLogoUrl" :src="footerLogoUrl" alt="lederhosen-land logo" class="footer-logo" />
      </div>
      <div class="lh-lg ms-lg-4 ms-xxl-5">
        <h5 class="mb-4">{{ $t("cookiebar_title") }}</h5>
        <p class="mb-0">{{ $t("cookiebar_text") }}</p>
        <form action="#" method="POST">
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 mt-xl-5 text-nowrap">
            <div class="border border-black mb-4 mb-md-0 px-4 py-2 rounded-3">
              <div class="row gx-5 fw-semibold">
                <div class="col">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="check01" checked disabled />
                    <label class="form-check-label">
                      {{ $t("cookiebar_necessary") }}
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="allCookies" name="check02" />
                    <label class="form-check-label" for="cookie-banner-settings">
                      {{ $t("cookiebar_other") }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-secondary btn-lg px-5 cookie-btn" type="button" @click="onClick">
              {{ $t("cookiebar_accept") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieBarWrap",
  components: {},

  data() {
    return {
      allCookies: true,
      isCookieAgreed: this.$cookies.isKey("websiteCookie"),
    };
  },
  computed: {
    headerLogo() {
      return this.$store.getters["headerlogo/getStoreLogo"];
    },
    footerLogoUrl() {
      if (!this.headerLogo) return "";
      return `${this.headerLogo.base_media_url}logo/${this.headerLogo.header_logo_src}`;
    },
  },
  methods: {
    onClick() {
      this.isCookieAgreed = true;
      this.$cookies.config("180d");
      this.$cookies.set("websiteCookie", this.allCookies);
      if (this.allCookies == true) {
        this.updateGoogleConsent("granted");
      } else {
        this.updateGoogleConsent("denied");
      }
    },
    setGoogleConsent(consent) {
      if (typeof window.gtag !== "function") {
        window.gtag = function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(arguments);
        };
      }
      window.gtag("consent", "default", this.formatConsent(consent));
    },
    updateGoogleConsent(consent) {
      window.gtag("consent", "update", this.formatConsent(consent));
    },
    formatConsent(consent) {
      return {
        ad_storage: consent,
        analytics_storage: consent,
        functionality_storage: consent,
        personalization_storage: consent,
        security_storage: "granted",
        ad_user_data: consent,
        ad_personalization: consent,
        wait_for_update: 2000,
      };
    },
  },
  mounted() {
    this.setGoogleConsent("denied");
    this.$gtm.enable(true);
    if (this.allCookies && this.isCookieAgreed) {
      this.updateGoogleConsent("granted");
    } else {
      this.updateGoogleConsent("denied");
    }
  },
};
</script>

<style></style>
